import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	routes: [
    {
    		path: '/',
    		redirect: '/authApp' //+ STATIC_CONFIG.home
			// redirect: '/' + STATIC_CONFIG.home
			
    	},
		{
			path: '/Auth',
			component: resolve => require(['../components/Auth.vue'], resolve)
		},
		{
			path: '/authPC',
			component: resolve => require(['../components/authPC.vue'], resolve)
		},
		{
			path: '/authApp',
			component: resolve => require(['../components/authApp.vue'], resolve)
		},
    {
    	path: '/home',
    	component: resolve => require(['../components/Home.vue'], resolve)
    },
    {
    	path: '/show_video',
    	component: resolve => require(['../page/show_video.vue'], resolve)
    },
    // {
    // 	path: '/home',
    // 	component: resolve => require(['../components/Home.vue'], resolve),
    // 	children: [{
    // 			path: '/',
    // 			component: resolve => require(['../page/home_Page.vue'], resolve),
    //                  meta: { keepAlive: true } // false为不缓存
    // 		},
    // 		{
    // 			path: '/show_video',
    // 			component: resolve => require(['../page/show_video.vue'], resolve),
    //        meta: { keepAlive: false } // false为不缓存
    // 		}
    // 	]
    // },
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js